import { firstValueFrom } from 'rxjs';
import { Component, EventEmitter, Input, OnInit, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { CartService, LocalizationService, LogService, MibpLogger, NoticebarService, QuickOrderLine, FrontendContextService, PermissionService } from 'root/services';
import { NoticeType } from '../noticebar/noticebar.enum';
import { AddItemToCartSource, CrossSellProductDetailsRequestDto, PriceAndAvailabilitySource, UpSellCrossSellProductRequestResponseDto } from 'root/mibp-openapi-gen/models';
import { CommonModule } from '@angular/common';
import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';
import { LoaderComponent } from 'root/shared/components/status/loader/loader.component';
import { ImageComponent } from 'root/components/image/image.component';
import { permissionPolicyKey } from 'root/services/permission';
import { crossSellsFnGetCrossSellProductDetails } from "root/mibp-openapi-gen/fn/cross-sells/cross-sells-fn-get-cross-sell-product-details";
import { MibpApiService } from "root/mibp-openapi-gen/mibp-api.service";
import { PriceStateComponent } from 'src/app/shared/components/status/price-state/price-state.component';
import { AvailabilityStateComponent } from 'src/app/shared/components/status/availability-state/availability-state.component';
import { SupportTeamProductStateMenuComponent } from 'src/app/shared/components/support-team/support-team-product-state-menu/support-team-product-state-menu.component';
import { ExpectedDeliveryDateStateComponent } from 'src/app/shared/components/status/expected-delivery-date-state/expected-delivery-date-state.component';
import { PriceStateContextDirective } from 'src/app/shared/directives/status/price-state-context/price-state-context.directive';


@Component({
  selector: 'mibp-cross-sell',
  templateUrl: './cross-sell.component.html',
  styleUrls: ['./cross-sell.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    ResourceStringComponent,
    LoaderComponent,
    ImageComponent,

    SupportTeamProductStateMenuComponent,
    PriceStateComponent,
    AvailabilityStateComponent,
    ExpectedDeliveryDateStateComponent,
    PriceStateContextDirective

  ]
})
export class CrossSellComponent implements OnInit {
  private mibpApiService = inject(MibpApiService);
  private localizationService = inject(LocalizationService);
  private noticeBarService = inject(NoticebarService);
  private cartService = inject(CartService);
  private logger = inject(LogService);
  private frontendContext = inject(FrontendContextService);
  private permissions = inject(PermissionService);
  protected priceAndAvailabilitySource = PriceAndAvailabilitySource.ActiveCart;

  isLoading = false;
  crossSellProducts: UpSellCrossSellProductRequestResponseDto[];
  log: MibpLogger;
  contactUsMessageRequestPrice: string;
  canSeeAvailability: boolean;
  canSeeExpectedDeliveryDate: boolean;
  @Input()
  set setCrossSellProductIds(crossSellProductIds: number[]) {
    if(!crossSellProductIds || crossSellProductIds.length < 1) {
      this.crossSellProducts = [];
      return;

    }
    this.getCrossSellProducts(crossSellProductIds);
  }

  @Output() crossSellProductAddedToCartEvent = new EventEmitter();
  @Output() closeDialogBox = new EventEmitter<boolean>();

 
  constructor() {
    const logger = this.logger;
    this.log = logger.withPrefix('crossSell-component');
  }

  ngOnInit(): void {
    this.canSeeExpectedDeliveryDate = this.permissions.test(permissionPolicyKey('canSeeExpectedDeliveryDate')); 
    this.localizationService.getResourceString('Carts_PriceForProductMessage').then((resourceStringValue) => {
      this.contactUsMessageRequestPrice = resourceStringValue;
    });
    this.canSeeAvailability = this.permissions.test(permissionPolicyKey('canSeeAvailability'));
  }

  getCrossSellProducts(crossSellProductIds: number[]): void {
    const languageCode = this.localizationService.getLang();
    this.isLoading = true;
    this.crossSellProducts = [];
    const request =  {
      crossSellProductIds: crossSellProductIds,
      languageCode : languageCode
    } as CrossSellProductDetailsRequestDto;

    firstValueFrom(this.mibpApiService.invoke(crossSellsFnGetCrossSellProductDetails, {body: request })).then((crossSellProducts) => {
      this.log.debug('response crossSellProducts ', crossSellProducts);
      this.crossSellProducts = crossSellProducts;

      setTimeout(() => {
        this.isLoading = false;
      }, 1000);

    }).catch(error => {
      this.isLoading = false;
      this.log.error('Error when fetching cross sell products', error);
      this.noticeBarService.show('Cross-sell_ErrorFetchingCrossSellProducts', NoticeType.Error);
    });
  }

  onAddToActiveCart (product: UpSellCrossSellProductRequestResponseDto) :void {
    this.isLoading = true;

    const products = [({
      productCode: product.code,
      productType: product.productType,
      quantity: 1 //Always qty 1 when adding cross sell products
    } as QuickOrderLine)];

    this.cartService.addToCart(products, AddItemToCartSource.CrossSell).then(ok => {
      this.crossSellProductAddedToCartEvent.emit();
      setTimeout(() => {
        this.isLoading = false;
      }, 3000);
    }).catch(err => {
      this.log.error("Could not add to active cart", err);
      this.isLoading = false;
      //
    });
  }
  
  protected onClickProductImage(productCode: string)
  {
    this.closeDialogBox.emit(true);
    this.frontendContext.Navigation.navigateToProductDetailsPage(productCode);
  }

}
